import React from 'react'

const BuyerIntentTrackingContext = React.createContext(true)

const BuyerIntentTrackingProvider = BuyerIntentTrackingContext.Provider

const useBuyerIntentTrackingEnabled = () => React.useContext(BuyerIntentTrackingContext)

export { BuyerIntentTrackingProvider, useBuyerIntentTrackingEnabled }
